export const APP_VERSION = 'V:082726B1';

export const RELEASE_NOTES = [
    {
        version: 'V:082726B1',
        releaseDate: 'August 27, 2026',
        items: ['Added release notes modal accessible from the footer version.'],
    },
];
